import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const GET_LOGS_BY_ID = 'GET_LOGS_BY_ID';
export const GET_LOGS_BY_ID_SUCCESS = 'GET_LOGS_BY_ID_SUCCESS';
export const GET_LOGS_BY_ID_FAIL = 'GET_LOGS_BY_ID_FAIL';
export const GET_LOGS_BY_ID_RESET = 'GET_LOGS_BY_ID_RESET';

export const getLogsById = (params) => {
    return {
        type: GET_LOGS_BY_ID,
        params,
    };
};

export const getLogsByIdSuccess = (response) => {
    return {
        type: GET_LOGS_BY_ID_SUCCESS,
        response,
    };
};

export const getLogsByIdFail = (response) => {
    return {
        type: GET_LOGS_BY_ID_FAIL,
        response,
    };
};

export const getLogsByIdReset = () => {
    return {
        type: GET_LOGS_BY_ID_RESET,
    };
};

export const getLogsByIdApi = (data) => {
    return (dispatch) => {
        dispatch(getLogsById());
        axios
            .get(`${config.api.base_url}/ml-logs/logs/${data.id}`, {
                params: data,
                headers: {
                    Authorization: 'Bearer ' + getUserToken(),
                },
            })
            .then((response) => {
                const getLogsByIdData = response.data;
                dispatch(getLogsByIdSuccess(getLogsByIdData));
            })
            .catch((error) => {
                const errorMsg = error.message;
                dispatch(getLogsByIdFail(errorMsg));
            });
    };
};
